import { FloatButton } from "antd";
import { useEffect, useState } from "react";
import "./scrolltotop.scss";

const ScrollToTop = () => {
  const [showTopBtn, setShowTopBtn] = useState(false);

  useEffect(() => {
    window.addEventListener("scroll", () => {
      if (window.scrollY > 500) {
        setShowTopBtn(true);
      } else {
        setShowTopBtn(false);
      }
    });
  }, []);

  const goToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <div
      className={`${showTopBtn ? "show-top-to-btn" : "hide-top-to-btn"
        } top-to-btm`}
    >
      <FloatButton
        onClick={goToTop}
        icon={<span className="material-symbols-sharp">arrow_upward</span>}
        shape="circle"
      />
    </div>
  );
};
export default ScrollToTop;
